const ffToDatePicker = (field) => ({
    state: field.state,
    hasError: field.error,
    domRef: field.domRef,
});
exports.ffToDatePicker = ffToDatePicker;
